import React from 'react';

const GeniusConnect: React.FC = () => {
    return (
        <div>
            <h1>Genius Connections</h1>
            <p>Connect with other geniuses</p>
            <p>This page is still under construction</p>
        </div>
    );
};

export default GeniusConnect;